<div class="spacing--margin-horizontal spacing--margin-top introtext">
  <div class="spacing--margin-bottom">
    <span class="text--small text--h5 label">
      {{ 'feed-profit.intro.title' | translate }}
    </span>
    <div class="spacing--margin-top flex--row flex--nowrap">
      <div class="flex--column">
        <span class="text--small text--gray label">
          {{ 'feed-profit.intro.paragraph1' | translate }}
        </span>
      </div>
    </div>
    <div class="spacing--margin-top flex--row flex--nowrap">
      <div class="flex--column">
        <span class="text--small text--gray label">
          {{ 'feed-profit.intro.paragraph2' | translate }}
        </span>
      </div>
    </div>
    <div class="spacing--margin-top flex--row flex--nowrap">
      <div class="flex--column">
        <span class="text--small text--gray label">
          {{ 'feed-profit.intro.paragraph3' | translate }}
        </span>
      </div>
    </div>
    <div class="flex--row flex--nowrap">
      <div class="flex--column text--small text--gray label">
        <ul>
          <li>
            {{ 'feed-profit.intro.startweight' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.piglet-price' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.slaughtered-weight' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.revenue' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.feed-packet-price' | translate }}
          </li>
        </ul>
      </div>
    </div>
    <div class="spacing--margin-top flex--row flex--nowrap">
      <div class="flex--column">
        <span class="text--small text--gray label">
          {{ 'feed-profit.intro.paragraph4' | translate }}
        </span>
      </div>
    </div>
    <div class="flex--row flex--nowrap">
      <div class="flex--column text--small text--gray label">
        <ul>
          <li>
            {{ 'feed-profit.intro.effect-square-meters' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.effect-type' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.effect-delivery-type' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.effect-startweight-delivery' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.effect-feed-package' | translate }}
          </li>
          <li>
            {{ 'feed-profit.intro.effect-fertilizer' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
